"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _partial = _interopRequireDefault(require("transmute/partial"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var SIGNUP_BASE_URL = 'https://app.hubspot.com/signup';
var StyledButton = (0, _styledComponents.default)(_UIButton.default).withConfig({
  displayName: "SignupButton__StyledButton",
  componentId: "b35vdq-0"
})([""]); // Not to be confused  with hubs signup url, this is the actual URL
// of the signup app we're sending the user to

function getSignupUrl(signupType) {
  return SIGNUP_BASE_URL + "/" + signupType;
}

var trackClick = function trackClick(sourceId, signupType) {
  (0, _getUsageTracker.default)().track('signupClick', {
    sourceId: sourceId,
    signupType: signupType
  });
};

var SignupButton = function SignupButton(_ref) {
  var sourceId = _ref.sourceId,
      className = _ref.className,
      use = _ref.use,
      ctaKey = _ref.ctaKey,
      signupType = _ref.signupType,
      products = _ref.products;
  var signupMerchId = _HubMap.default[signupType] ? _HubMap.default[signupType].highlightedFreeMerch : _MerchandiseIds.PRODUCT_CRM;
  var hubsSignupUrl = (0, _publicPageUrls.getHubsSignupUrl)({
    products: products,
    merchandiseId: signupMerchId
  });
  var hubsSignupCta = sourceId;
  var gaClassName = (0, _publicPageUrls.getGAClassName)(hubsSignupCta);
  var HREF = getSignupUrl(signupType) + "?hubs_signup-url=" + hubsSignupUrl + "&hubs_signup-cta=" + hubsSignupCta;
  return _react.default.createElement(StyledButton, {
    use: use,
    href: HREF,
    className: gaClassName + " " + className,
    onClick: (0, _partial.default)(trackClick, sourceId, signupType)
  }, _react.default.createElement(_FormattedMessage.default, {
    message: ctaKey,
    className: gaClassName
  }));
};

SignupButton.defaultProps = {
  use: 'primary',
  ctaKey: 'pricingPage.signupCtas.getStartedFree',
  signupType: 'crm'
};
SignupButton.propTypes = {
  sourceId: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  use: _propTypes.default.string,
  ctaKey: _propTypes.default.string,
  signupType: _propTypes.default.oneOf(['crm', 'marketing', 'sales', 'service']).isRequired,
  products: _propTypes.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(SignupButton);

exports.default = _default;
module.exports = exports.default;